module.exports = __webpack_public_path__ + "static/img/qd12.b51cbaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/qualificationDoc/qd12.jpg
// module id = fqMb
// module chunks = 1